import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useDispatch, useSelector } from 'react-redux';
import { setGetMailing } from '../../../../store/mailing/thunk/setGetMailing';
import MailingItem from '../../components/MailingItem';

const MailingList = () => {
    const dispatch = useDispatch();
    const [page, setPage] = React.useState(1);

    React.useEffect(() => {
        dispatch(setGetMailing({
            page,
            pageSize: 25
        }))
    }, []);

    const mailing = useSelector((state) => state.mailing.list);

    return (
        <div style={{
            padding: '0 20px 20px',
        }}>
            <Title
                label="Рассылки"
            />
            <div style={{ display: 'flex', flexDirection: 'column', rowGap: 12 }}>
                {
                    mailing.data?.map((item) => (
                        <MailingItem {...item} />
                    ))
                }
            </div>

            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <button type="button" onClick={() => {
                    dispatch(setGetMailing({
                        page,
                        pageSize: (page + 1) * 25
                    }))
                    setPage(page + 1)
                }} style={{
                    color: '#141b33',
                    cursor: 'pointer',
                    padding: '10px 0',
                    width: '100%',
                    background: '#ffc324',
                    borderRadius: '4px',
                    border: 'none',
                    outline: 'none'
                }}>Показать еще</button>
            </div>
        </div>
    )
}

export default MailingList;